import Vue from 'vue';

export default {
  isExpired() {
    if (Vue.$jwt.hasToken()) {
      const payload = Vue.$jwt.decode();
      const now = Date.now();
      return payload && (payload.exp < now / 1000);
    }
    return true;
  },
  user() {
    return Vue.$jwt.decode().user;
  },
  fullName() {
    return Vue.$jwt.decode().user.fullName;
  },
  hasEditRights() {
    const user = Vue.$jwt.decode().user;
    return user && user.hasEditRights;
  },
  hasViewRights() {
    const user = Vue.$jwt.decode().user;
    return user && user.hasViewRights;
  },
  isAdmin() {
    const user = Vue.$jwt.decode().user;
    return user && user.isAdmin;
  },
  hasSchedulerRights() {
    const user = Vue.$jwt.decode().user;
    return user && user.isScheduler;
  },
  // USER CAN ONLY ACCESS SERVICE LOGS IF THEY HAVE EDIT OR VIEW RIGHTS
  hasServiceLogRights() {
    const user = Vue.$jwt.decode().user;
    return user && (user.hasEditRights || user.hasViewRights);
  },
  // this user has access to both the scheduler and service log app
  hasFullRights() {
    const user = Vue.$jwt.decode().user;
    return user && (user.hasEditRights || user.hasViewRights) && user.isScheduler;
  },
  credType() {
    const user = Vue.$jwt.decode().user;
    return user && user.credentialType;
  },
  credName() {
    const user = Vue.$jwt.decode().user;
    return user && user.credentialName;
  }
};



// WEBPACK FOOTER //
// ./src/jwt-token/index.js